/* eslint-disable no-useless-return */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import initialState from '../helpers/form-helpers/initial-state';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import FormSpinner from '../../common/utility/FormSpinner';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import { deepCopyObject } from '../../utils/obj-utils';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import {
    getProperty, hasValue, isNullOrUndefined, parametersDidUpdate, toggleCssClass
} from '../../../../../general/js/general-helpers';
import { hasFormFields } from '../helpers/form-helpers/form-field-helpers';
import * as itemListFormActions from '../../../store/actions/item-list-form-actions';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { reloadPageWithoutQueryParams } from '../../../../../general/js/utils';

class SSOItemListForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...initialState.ssoItemListFormState
        };

        this.formMessageRef = React.createRef();
        this.formReferences = [];

        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.buildFormRefs = this.buildFormRefs.bind(this);
        this.displayItemListForm = this.displayItemListForm.bind(this);
        this.loadSSOItemListFormData = this.loadSSOItemListFormData.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);

        this.loadSSOItemListFormData();
    }

    loadSSOItemListFormData() {
        const {
            actions,
            formData,
            isFormLoadSuccessful,
            itemListErrorMessages,
            formId
        } = this.props;

        if (!hasValue(formData) && hasValue(actions) && (!isFormLoadSuccessful && !hasValue(itemListErrorMessages))) {
            actions.loadSSOItemListFormData(formMessageConstants.emptyString, formId);
        }
    }

    componentDidMount() {
        this.loadFields();
        this.hideModalCloseButton();
        this.addListeners();
    }

    componentWillUnmount() {
        this.removeListeners();
    }

    componentWillReceiveProps(nextProps) {
        const {
            isFormLoadSuccessful,
            itemListErrorMessages,
            loading
        } = nextProps;

        const oldItemList = getProperty(this.props.formData, formFieldConstants.itemList);
        const newItemList = getProperty(nextProps.formData, formFieldConstants.itemList);

        if (!parametersDidUpdate(oldItemList, newItemList)) {
            return;
        }

        this.hideModalCloseButton(nextProps);

        if (!loading && isFormLoadSuccessful && !hasValue(itemListErrorMessages)) {
            this.loadFields(nextProps);
            return;
        }
    }

    loadFields(nextProps = {}) {
        const { formData } = hasValue(nextProps) ? nextProps : this.props;

        if (!hasValue(formData)) {
            return;
        }

        const { itemList } = formData;

        if (!hasValue(itemList)) {
            return;
        }

        this.setState(formStateHelpers.loadTextAndImageFields(itemList));
    }

    hideModalCloseButton(nextProps = {}) {
        const { formData } = hasValue(nextProps) ? nextProps : this.props;
        const { hideCloseButton } = hasValue(formData) ? formData : { hideCloseButton: false };

        if (hideCloseButton) {
            const closeButton = document.querySelector('.modal__close');

            if (!isNullOrUndefined(closeButton)) {
                toggleCssClass(closeButton, 'is-hidden', hideCloseButton);
            }
        }
    }

    buildFormRefs() {
        if (!hasValue(this.formReferences) && hasFormFields(this.state)) {
            this.formReferences = formScrollHelpers.getFormReferences(this.state);
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const { handleBallotPortalRedirect, isFromBallot } = this.props;

        if (!hasValue(handleBallotPortalRedirect) || !isFromBallot) {
            reloadPageWithoutQueryParams();
            return;
        }

        this.removeListeners();
        handleBallotPortalRedirect();
    }

    addListeners() {
        document.addEventListener('keydown', this.handleModalClose);
    }

    removeListeners() {
        document.removeEventListener('keydown', this.handleModalClose);
    }

    handleModalClose(event) {
        if (event.keyCode === 27) {
            event.preventDefault();
            reloadPageWithoutQueryParams();
        }
    }

    displayForm() {
        const {
            formData
        } = this.props;

        if (!hasValue(formData)) {
            return null;
        }

        const { submitButtonText, useYellowButton } = formData;
        const footerButtonText = hasValue(submitButtonText) ? submitButtonText : formMessageConstants.upgradeAccountResale;

        return (<Fragment>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    formRef={this.formMessageRef}
                    isSuccessMessage={true}
                    messages={['']}></FormMessage>
                {this.displayItemListForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    footerButtonText={footerButtonText}
                    useYellowButton={useYellowButton}
                ></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displayItemListForm() {
        const copyOfFormData = deepCopyObject(this.state);

        this.buildFormRefs();

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences
        });
    }

    render() {
        const { formData, loading } = this.props;

        const formBanner = getProperty(formData, 'formBanner');

        return (
            <div className='modal__content form-container'>
                <div className='constrain-tablet ff-founders fs-14'>
                    {
                        hasValue(formBanner) &&
                        <RegisterFormBanner
                            formBanner={formBanner}></RegisterFormBanner>
                    }
                    <section className='form-popup__content'>
                        {(loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </section>
                </div>
            </div>
        );
    }
}

SSOItemListForm.propTypes = {
};

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        formData: !hasValue(ownProps.formData) ? state.itemListForm.itemListFormData : ownProps.formData,
        itemListErrorMessages: state.itemListForm.itemListErrorMessages,
        isFormLoadSuccessful: state.itemListForm.isFormLoadSuccessful
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadSSOItemListFormData: bindActionCreators(itemListFormActions.loadSSOItemListFormData, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SSOItemListForm);
